import Cookies from 'universal-cookie';
import { browser } from 'legacy-src/utility/browserDetection';

/* eslint-disable */

/*
 * This is a carbon-copy of the custom-protocol-check package
 * https://www.npmjs.com/package/custom-protocol-check
 * It was added here so that we have some control over how it's transpiled.
 * For some reason, the package itself was not being correctly transpiled
 */

const DEFAULT_CUSTOM_PROTOCOL_FAIL_CALLBACK_TIMEOUT = 2000;

function registerEvent(target, eventType, cb) {
  if (target.addEventListener) {
    target.addEventListener(eventType, cb);
    return {
      remove: function () {
        target.removeEventListener(eventType, cb);
      },
    };
  } else {
    target.attachEvent(eventType, cb);
    return {
      remove: function () {
        target.detachEvent(eventType, cb);
      },
    };
  }
}

function createHiddenIframe(target, uri) {
  let iframe = document.createElement('iframe');
  iframe.src = uri;
  iframe.id = 'hiddenIframe';
  iframe.style.display = 'none';
  target.appendChild(iframe);
  return iframe;
}

function openUriWithHiddenFrame(uri, failCb, successCb) {
  const handler = registerEvent(window, 'blur', onBlur);
  let timeout;

  let iframe = document.querySelector('#hiddenIframe');
  if (!iframe) {
    iframe = createHiddenIframe(document.body, 'about:blank');
  }

  function onBlur() {
    timeout && clearTimeout(timeout);
    handler.remove();
    successCb();
  }

  timeout = setTimeout(function () {
    failCb();
    handler.remove();
  }, DEFAULT_CUSTOM_PROTOCOL_FAIL_CALLBACK_TIMEOUT);

  iframe.contentWindow.location.href = uri;
}

function openUriWithTimeoutHack(uri, failCb, successCb) {
  //handle page running in an iframe (blur must be registered with top level window)
  let target = window;
  while (target.parent && target != target.parent) {
    target = target.parent;
  }
  const handler = registerEvent(target, 'blur', onBlur);
  const pageHideHandler = registerEvent(target, 'pagehide', onBlur);

  let timeout;
  function onBlur() {
    timeout && clearTimeout(timeout);
    handler.remove();
    pageHideHandler.remove();
    successCb();
  }

  timeout = setTimeout(function () {
    failCb();
    handler.remove();
    pageHideHandler.remove();
  }, DEFAULT_CUSTOM_PROTOCOL_FAIL_CALLBACK_TIMEOUT);

  window.location = uri;
}

const openUriUsingFirefox = (uri, failCb, successCb) => {
  let iframe = document.querySelector('#hiddenIframe');

  if (!iframe) {
    iframe = createHiddenIframe(document.body, 'about:blank');
  }

  try {
    iframe.contentWindow.location.href = uri;
    successCb();
  } catch (e) {
    if (e.name == 'NS_ERROR_UNKNOWN_PROTOCOL') {
      failCb();
    }
  }
};

const openUriWithMsLaunchUri = (uri, failCb, successCb) => {
  navigator.msLaunchUri(uri, successCb, failCb);
};

const getBrowserVersion = () => {
  const ua = window.navigator.userAgent;
  let tem,
    M =
      ua.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i,
      ) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return parseFloat(tem[1]) || '';
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) {
      return parseFloat(tem[2]);
    }
  }
  M = M[2]
    ? [M[1], M[2]]
    : [window.navigator.appName, window.navigator.appVersion, '-?'];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
  return parseFloat(M[1]);
};

export default (uri, failCb, successCb, unsupportedCb) => {
  const failCallback = () => {
    failCb && !browser.isChrome() && failCb();
  };

  const successCallback = () => {
    successCb && successCb();
  };

  const unsupportedCallback = () => {
    unsupportedCb && !browser.isChrome() && unsupportedCb();
  };

  const hasChromeBookLDBExtension = () => {
    const cookies = new Cookies();
    const ldbCookieVal = cookies.get('cbLDBex');
    return parseInt(ldbCookieVal, 10) === 1;
  };

  const openUri = () => {
    if (browser.isFirefox()) {
      const browserVersion = getBrowserVersion();
      if (browserVersion >= 64) {
        openUriWithHiddenFrame(uri, failCallback, successCallback);
      } else {
        openUriUsingFirefox(uri, failCallback, successCallback);
      }
    } else if (hasChromeBookLDBExtension() && browser.isChromeBook()) {
      // is personal chromebook and ldb extension is installed
      const uriToOpen = `data://text/plain:${uri}`;
      openUriWithHiddenFrame(uriToOpen, failCallback, successCallback);
    } else if (browser.isChrome() || browser.isIPad()) {
      openUriWithTimeoutHack(uri, failCallback, successCallback);
    } else if (browser.isOSX()) {
      openUriWithHiddenFrame(uri, failCallback, successCallback);
    } else {
      //not supported, implement please
      unsupportedCallback();
    }
  };

  if (browser.isEdge() || browser.isIE()) {
    //for IE and Edge in Win 8 and Win 10
    openUriWithMsLaunchUri(uri, failCb, successCb);
  } else {
    if (document.hasFocus()) {
      openUri();
    } else {
      let focusHandler = registerEvent(window, 'focus', () => {
        focusHandler.remove();
        openUri();
      });
    }
  }
};

/* eslint-enable */
